import axios from './BaseService';

const API_URL = process.env.REACT_APP_API_URL;

export async function sendTestEmail(to, subject, message) {
    const url = `${API_URL}/settings/test-email`;
    const payload = {
        to,
        subject,
        message
    };

    const response = await axios.post(url, payload);
    return response.data;
}




